(function () {
  'use strict';

  const STORAGE_KEY = 'product-view-mode';

  /* =========================================================
     SETTINGS
  ========================================================= */

  const THERMAL_COLLECTION_HANDLES = [
    'autel-thermal-drone'
  ];

  const DESKTOP_LIMIT = 8;
  const MOBILE_LIMIT = 6;


  /* =========================================================
     PRODUCT GRID
  ========================================================= */

  function getProductGrid() {
    const container = document.getElementById('ProductGridContainer');

    if (!container) return null;

    return container.querySelector('#product-grid.product-grid');
  }


  /* =========================================================
     GRID / LIST VIEW
     Existing function
  ========================================================= */

  function updateView(view) {
    const grid = getProductGrid();

    if (!grid) return;

    const mode = view === 'list' ? 'list' : 'grid';

    grid.classList.remove('grid-view', 'list-view');
    grid.classList.add(`${mode}-view`);

    document
      .querySelectorAll('.view-mode-selector .view-btn')
      .forEach((btn) => {
        btn.classList.toggle(
          'active',
          btn.dataset.view === mode
        );
      });
  }


  /* =========================================================
     CHECK THERMAL COLLECTION
  ========================================================= */

  function isThermalCollection(grid) {
    if (!grid) return false;

    const handle =
      (grid.dataset.collectionHandle || '')
        .trim()
        .toLowerCase();

    return THERMAL_COLLECTION_HANDLES.includes(handle);
  }


  /* =========================================================
     GET PRODUCT ITEMS
  ========================================================= */

  function getProductItems(grid) {
    if (!grid) return [];

    return Array.from(
      grid.querySelectorAll(':scope > .grid__item')
    );
  }


  /* =========================================================
     GET DISPLAY LIMIT
  ========================================================= */

  function getProductLimit() {
    return window.innerWidth < 750
      ? MOBILE_LIMIT
      : DESKTOP_LIMIT;
  }


  /* =========================================================
     REMOVE OLD TOGGLE
     Needed after Shopify AJAX filtering/sorting
  ========================================================= */

  function removeExistingToggle() {
    document
      .querySelectorAll('.thermal-product-toggle')
      .forEach((toggle) => toggle.remove());
  }


  /* =========================================================
     RESET PRODUCTS
  ========================================================= */

  function resetProducts(grid) {
    if (!grid) return;

    getProductItems(grid).forEach((item) => {
      item.classList.remove('thermal-product-hidden');
    });
  }


  /* =========================================================
     CREATE TOGGLE
  ========================================================= */

  function createThermalToggle(grid) {
    const products = getProductItems(grid);

    if (!products.length) return null;

    const limit = getProductLimit();

    if (products.length <= limit) {
      return null;
    }

    const toggle = document.createElement('div');

    toggle.className = 'thermal-product-toggle';

    toggle.innerHTML = `
      <span
        class="thermal-product-toggle__line"
        aria-hidden="true"
      ></span>

      <button
        type="button"
        class="thermal-product-toggle__button"
        aria-expanded="false"
      >
        <span class="thermal-product-toggle__text"></span>

        <span
          class="thermal-product-toggle__icon"
          aria-hidden="true"
        ></span>
      </button>

      <span
        class="thermal-product-toggle__line"
        aria-hidden="true"
      ></span>
    `;

    grid.insertAdjacentElement(
      'afterend',
      toggle
    );

    return toggle;
  }


  /* =========================================================
     UPDATE BUTTON TEXT
  ========================================================= */

  function updateToggleText(
    toggle,
    expanded,
    hiddenCount
  ) {
    if (!toggle) return;

    const text =
      toggle.querySelector(
        '.thermal-product-toggle__text'
      );

    const button =
      toggle.querySelector(
        '.thermal-product-toggle__button'
      );

    if (!text || !button) return;

    if (expanded) {
      text.textContent = 'Show Less';

      toggle.classList.add('is-expanded');

      button.setAttribute(
        'aria-expanded',
        'true'
      );

    } else {
      text.textContent =
        `View All Thermal Drones (${hiddenCount} more)`;

      toggle.classList.remove('is-expanded');

      button.setAttribute(
        'aria-expanded',
        'false'
      );
    }
  }


  /* =========================================================
     APPLY COLLAPSED STATE
  ========================================================= */

  function collapseProducts(
    grid,
    toggle
  ) {
    const products = getProductItems(grid);

    const limit = getProductLimit();

    products.forEach((item, index) => {
      item.classList.toggle(
        'thermal-product-hidden',
        index >= limit
      );
    });

    const hiddenCount =
      Math.max(products.length - limit, 0);

    updateToggleText(
      toggle,
      false,
      hiddenCount
    );

    grid.dataset.thermalExpanded = 'false';
  }


  /* =========================================================
     EXPAND PRODUCTS
  ========================================================= */

  function expandProducts(
    grid,
    toggle
  ) {
    const products = getProductItems(grid);

    products.forEach((item) => {
      item.classList.remove(
        'thermal-product-hidden'
      );
    });

    updateToggleText(
      toggle,
      true,
      0
    );

    grid.dataset.thermalExpanded = 'true';
  }


  /* =========================================================
     INIT THERMAL COLLECTION
  ========================================================= */

  function initThermalCollapse() {
    const grid = getProductGrid();

    removeExistingToggle();

    if (!grid) return;

    resetProducts(grid);

    if (!isThermalCollection(grid)) {
      delete grid.dataset.thermalExpanded;
      return;
    }

    const products = getProductItems(grid);

    const limit = getProductLimit();

    if (products.length <= limit) {
      delete grid.dataset.thermalExpanded;
      return;
    }

    const toggle =
      createThermalToggle(grid);

    if (!toggle) return;

    collapseProducts(
      grid,
      toggle
    );


    /* =========================================================
       CLICK
    ========================================================= */

    const button =
      toggle.querySelector(
        '.thermal-product-toggle__button'
      );

    if (!button) return;

    button.addEventListener(
      'click',
      function () {
        const expanded =
          grid.dataset.thermalExpanded === 'true';

        if (expanded) {

          collapseProducts(
            grid,
            toggle
          );

          /*
           * Bring the visible product area back into view
           * after collapsing.
           */

          const products =
            getProductItems(grid);

          const limit =
            getProductLimit();

          const lastVisible =
            products[
              Math.min(
                limit - 1,
                products.length - 1
              )
            ];

          if (lastVisible) {
            window.setTimeout(
              function () {
                lastVisible.scrollIntoView({
                  behavior: 'smooth',
                  block: 'end'
                });
              },
              50
            );
          }

        } else {

          expandProducts(
            grid,
            toggle
          );

        }
      }
    );
  }


  /* =========================================================
     GRID / LIST BUTTON
  ========================================================= */

  document.addEventListener(
    'click',
    (event) => {
      const btn =
        event.target.closest(
          '.view-mode-selector .view-btn'
        );

      if (!btn || !btn.dataset.view) return;

      event.preventDefault();
      event.stopPropagation();

      updateView(btn.dataset.view);

      localStorage.setItem(
        STORAGE_KEY,
        btn.dataset.view
      );
    }
  );


  /* =========================================================
     DOM READY
  ========================================================= */

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      updateView(
        localStorage.getItem(STORAGE_KEY) ||
        'grid'
      );

      initThermalCollapse();
    }
  );


  /* =========================================================
     SHOPIFY PRODUCT GRID UPDATED
     Sorting / Filtering / AJAX
  ========================================================= */

  document.addEventListener(
    'productgrid:updated',
    () => {
      updateView(
        localStorage.getItem(STORAGE_KEY) ||
        'grid'
      );

      initThermalCollapse();
    }
  );


  /* =========================================================
     RESPONSIVE
  ========================================================= */

  let resizeTimer;
  let previousMobileState =
    window.innerWidth < 750;

  window.addEventListener(
    'resize',
    () => {
      clearTimeout(resizeTimer);

      resizeTimer =
        window.setTimeout(
          () => {
            const currentMobileState =
              window.innerWidth < 750;

            /*
             * Only rebuild when crossing
             * desktop/mobile breakpoint.
             */

            if (
              currentMobileState !==
              previousMobileState
            ) {
              previousMobileState =
                currentMobileState;

              initThermalCollapse();
            }
          },
          150
        );
    }
  );

})();